
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  Address.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\Address.ts

import {Country } from "./Country";
export class Address {

  // int Id
  public Id: number=0;

  // string Addr1
  public Addr1?: string=null;

  // string Addr2
  public Addr2?: string=null;

  // string Addr3
  public Addr3?: string=null;

  // string Addr4
  public Addr4?: string=null;

  // string PostalCod
  public PostalCod?: string=null;

  // string City
  public City?: string=null;

  // int? CountryId
  public CountryId?: number=null;

  // string AddrNum
  public AddrNum?: string=null;

  // Country Country
  public Country: Country=null;
}